import "./src/styles/global.css";

if (typeof window !== "undefined" && "serviceWorker" in navigator && window.location.hostname === "localhost") {
  window.addEventListener("load", async () => {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));

    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }

    if (navigator.serviceWorker.controller) {
      window.location.reload();
    }
  });
}
